import { motion } from "framer-motion";

const items = [
  "Arquitectura",
  "Construcción",
  "Diseño",
  "Gestoría",
  "Naves Industriales",
  "Casa Habitación",
  "Terracería",
  "Desarrollador",
  "Administración",
  "Render 3D",
];

function MarqueeRow({ direction = 1, speed = 30 }) {
  return (
    <div className="flex overflow-hidden whitespace-nowrap">
      <motion.div
        animate={{ x: direction > 0 ? [0, -2400] : [-2400, 0] }}
        transition={{ repeat: Infinity, duration: speed, ease: "linear" }}
        className="flex flex-shrink-0"
      >
        {[...items, ...items, ...items].map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center text-6xl md:text-7xl lg:text-8xl font-light tracking-tight text-neutral-100 mx-4 md:mx-6 select-none"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            {item}
            <span className="mx-4 md:mx-6 text-neutral-200/50 text-4xl">+</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="py-12 md:py-16 overflow-hidden bg-white" data-testid="marquee-section">
      <MarqueeRow direction={1} speed={40} />
    </section>
  );
}
